import { Action, Reducer } from 'redux';
import {
  ReasonState,
  ReasonTypes,
  ReasonActionTypes
} from './reasonTypes';

export const INITIAL_STATE: ReasonState = {
  reason: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const reasonReducer: Reducer<ReasonState> = (
  state: ReasonState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ReasonActionTypes;
  switch (actionTypes.type) {
    case ReasonTypes.GET_REASON:
      return {
        ...state,
        reason: { ...state.reason, isLoading: true }
      };
    case ReasonTypes.SAVE_REASON:
      return {
        ...state,
        reason: {
          ...state.reason,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case ReasonTypes.RESET_REDUCER_REASON:
      return {
        ...state,
        reason: INITIAL_STATE.reason
      };
    default:
      return state;
  }
};

export default reasonReducer;
